
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 // Offers javascript

      function myFunctionsmo() {
        var dotsmo = document.getElementById("dotsmo");
        var moreTextsmo = document.getElementById("moresmo");
        var btnTextsmo = document.getElementById("myBtnsmo");

        if (dotsmo.style.display === "none") {
          dotsmo.style.display = "inline";
          btnTextsmo.innerHTML =
            'See 3 More Offers <i class="fa-sharp fa-solid fa-chevron-down" aria-hidden="true"></i>';
          moreTextsmo.style.display = "none";
        } else {
          dotsmo.style.display = "none";
          btnTextsmo.innerHTML =
            'See 3 More Offers <i class="fa-sharp fa-solid fa-chevron-up" aria-hidden="true"></i>';
          moreTextsmo.style.display = "inline";
        }
      }
    
// offer javascript ends here


// this code will prevent to redirect to cart or any page

$("#myBtnsmo, .accordion1").click(function (e) {
        e.preventDefault(); // this will stop page reloading and redirections
    });
// ends here


// Product description 

window.onload = function () {
  var elementacc = document.getElementById("mybtndetails");
  elementacc.click();
};
  
  var acc = document.getElementsByClassName("accordion1");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active1");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }

// Product description ends here

$(document).ready(function(){
  $('.custom-addtocartbtn-product').click(function(){
    var v_id = $(this).attr('data-id');
    console.log(v_id);
  var formOBJ = {
	  quantity: 1,
	  id: v_id
	};
	
	$.ajax({
		type: "POST",
		url: "/cart/add.js",
		cache:false,
		data:formOBJ,
		dataType: "json",
		success: function (data) {
			
			//how do I update/refresh/reload the cart drawer here?
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
          }));
          console.log("success");

          var cartDrawerButtonSelector = "Header__Icon Icon-Wrapper Icon-Wrapper--clickable ";
    	  var cartDrawerButton = document.getElementsByClassName(cartDrawerButtonSelector)[2];
          cartDrawerButton.click();

          
          // $('html').addClass('no-scroll');
          // $('.PageOverlay').addClass('is-visible');
          // $('#sidebar-cart').attr('aria-hidden', 'false');
		},
		error: function (xhr, ajaxOptions, thrownError) {
			console.log("error");
			console.log(xhr.status);
			console.log(thrownError);
		}
	});
   
  });
});




